/* eslint-disable array-callback-return, consistent-return */
export const cartProducts = state =>
  state.cart.added
    .map(({ product_id, quantity }) => {
      const product = state.products.all.find(p => p.id === product_id);

      if (product) {
        product.quantity = quantity;
        return product;
      }
    })
    .filter(product => product);

export const totals = state => state.cart.totals;
